module.exports = __webpack_public_path__ + "img/twitter.4cf55432.svg";